import { render } from "./verify.vue?vue&type=template&id=fa5352e4&scoped=true&ts=true"
import script from "./verify.vue?vue&type=script&lang=ts"
export * from "./verify.vue?vue&type=script&lang=ts"

import "./verify.vue?vue&type=style&index=0&id=fa5352e4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5352e4"]])

export default __exports__